import axios from 'axios';
import netteForms from 'nette-forms';

export function initAxios() {
	axios.defaults.headers = {
		"x-requested-with": "XMLHttpRequest"
	};

	axios.defaults.transformRequest = [(data, headers) => {
		const formData = new FormData();
		Object.keys(data).forEach(key => {
			if (data[key] instanceof Object) {
				formData.append(key, JSON.stringify(data[key]));
			} else {
				formData.append(key, data[key]);
			}
		});
		return formData;
	}];
};

// https://levelup.gitconnected.com/debounce-in-javascript-improve-your-applications-performance-5b01855e086
export function debounce(func, wait) {
	let timeout;

	return function executedFunction(...args) {
	  const later = () => {
		clearTimeout(timeout);
		func(...args);
	  };

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};

export function initCloseButtons() {
	document.addEventListener("DOMContentLoaded", () => {
		let closeButtons = Array.prototype.slice.call(document.querySelectorAll(".delete"), 0);

		closeButtons.forEach((el: HTMLButtonElement) => {
			el.addEventListener("click", (ev) => {
				ev.preventDefault();
				let parent = el.parentElement;
				while (parent !== null) {
					if (parent.classList.contains("notification") || parent.classList.contains("modal")) {
						parent.style.display = "none";
						parent = null;
					} else {
						parent = parent.parentElement;
					}
				}

				const activeModals = Array.prototype.slice.call(document.querySelectorAll(".modal.is-active"), 0);
				const html = <HTMLHtmlElement>document.getElementsByTagName("html")[0];
				html.classList.remove("is-clipped");

				activeModals.forEach((el: HTMLDivElement) => {
					el.style.display = "";
					el.classList.remove("is-active");
				});
			});
		});
	});
};

export function initHideNavbarOnScroll(navbarID: string) {
	let prevScrollpos = window.pageYOffset;
	let navbar = document.getElementById(navbarID);
	window.onscroll = function() {
		if (navbar !== null) {
			let currentScrollPos = window.pageYOffset;
			if (prevScrollpos > currentScrollPos) {
				navbar.style.top = "0";
			} else {
				navbar.style.top = "-50px";
			}
			prevScrollpos = currentScrollPos;
		}
	}
}

export function showModal(modalID: string) {
	const modal = <HTMLDivElement>document.getElementById(modalID);
	const html = <HTMLHtmlElement>document.getElementsByTagName("html")[0];
	modal.classList.add("is-active");
	html.classList.add("is-clipped");
}

export function hideModal(modalID: string) {
	const modal = <HTMLDivElement>document.getElementById(modalID);
	const html = <HTMLHtmlElement>document.getElementsByTagName("html")[0];
	modal.classList.remove("is-active");
	html.classList.remove("is-clipped");
}

export function initForms() {
	netteForms.initOnLoad();
}

export function initFlashes() {
	document.addEventListener("DOMContentLoaded", () => {
		(document.querySelectorAll(".notification .delete") || []).forEach(($delete) => {
			const $notification = $delete.parentNode;
			setTimeout(() => {
				if ($delete.parentElement !== null) {
					$delete.parentElement.style.display = "none";
				}
			}, 5000);
			$delete.addEventListener('click', () => {
				if ($notification !== null && $notification.parentNode !== null) {
					$notification.parentNode.removeChild($notification);
				}
			});
		});
	});
}
